(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('storage', {
            parent: 'admin',
            url: '/storage',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'storage.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/storage/storage.html',
                    controller: 'StorageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();